var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleFooter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 830,
    height: 631,
    viewBox: "0 0 830 631",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.542 58.6653L654.506 198.323L652.541 474.235L412.612 610.489L174.648 470.831L176.613 194.92L416.542 58.6653Z",
    stroke: "#FFE713",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M431.116 56.841L663.373 210.033L646.833 487.769L398.037 612.313L165.78 459.122L182.32 181.385L431.116 56.841Z",
    stroke: "#FFBD13",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.409 57.0981L641.297 172.309L668.464 449.788L441.745 612.056L187.857 496.844L160.689 219.365L387.409 57.0981Z",
    stroke: "#FF7F38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M397.182 57.4716L645.86 180.96L663.255 458.065L431.972 611.683L183.294 488.194L165.899 211.089L397.182 57.4716Z",
    stroke: "url(#paint0_linear_79_255)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_255",
    x1: 274.573,
    y1: 138.134,
    x2: 519.736,
    y2: 552.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8139"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleFooter1);
export default __webpack_public_path__ + "static/media/circle-footer-1.0ca83b169a691789127672de2e6f7c42.svg";
export { ForwardRef as ReactComponent };